import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import Tooltip from '@mui/material/Tooltip';
import Icon from '@mui/material/Icon';

const styles = {
    button: {
        display: 'inline-block',
        verticalAlign: 'middle',
        cursor: 'pointer',
        userSelect: 'none',
    },
    icon: {
        fontSize: 12,
    },
};

function CopyButton(props) {
    const { style, iconStyle, text, hintDirection = 'right' } = props;

    const [copied, setCopied] = React.useState(false);

    return (
        <CopyToClipboard text={text} onCopy={() => setCopied(true)}>
            <span style={{ ...styles.button, ...(style || {}) }}>
                <Tooltip
                    placement={hintDirection}
                    title={copied ? 'Copied!' : 'Copy'}
                    leaveDelay={copied ? 2000 : 0}
                    onClose={() => setCopied(false)}
                    arrow
                >
                    <Icon style={{ ...styles.icon, ...(iconStyle || {}) }}>
                        content_copy
                    </Icon>
                </Tooltip>
            </span>
        </CopyToClipboard>
    );
}

export default CopyButton;
